import { IconButton } from '@mui/material';
import { StyledDialogTitle } from 'components/core/ConfirmationDialog/style';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';

interface Props {
  dialogTitle: React.ReactNode;
  close: () => void;
  hasHeaderCancelButton: boolean;
  headerMenuProps?: {
    /** Ideally pass in a drawer component from mui */
    HeaderMenu: React.ReactNode;
    openHeaderMenu: () => void;
  };
  LeftHeaderComponent?: React.ReactNode;
}

export const ConfirmationDialogHeader = ({
  dialogTitle,
  hasHeaderCancelButton,
  close,
  headerMenuProps,
  LeftHeaderComponent,
}: Props) => {
  return (
    <>
      <StyledDialogTitle id="alert-dialog-title">
        {LeftHeaderComponent}
        {headerMenuProps ? (
          <IconButton onClick={headerMenuProps.openHeaderMenu} size="large">
            <MenuIcon />
          </IconButton>
        ) : null}
        {dialogTitle}
        {hasHeaderCancelButton ? (
          <IconButton onClick={close} size="large">
            <CloseIcon color="error" />
          </IconButton>
        ) : null}
      </StyledDialogTitle>

      {headerMenuProps?.HeaderMenu}
    </>
  );
};
